const SectionHeader = ({
  headerText,
  extraElement,
}: {
  headerText: string;
  extraElement?: React.ReactNode;
}) => {
  // rendering custom section header component here
  return (
    <div className='flex items-center justify-between pb-1 border-b-[3px] border-legal-dark-blue mb-5'>
      <h2 className='flex-1 italic capitalize font-semibold text-2xl md:text-3xl text-legal-dark-blue text-center md:text-left'>
        {headerText}
      </h2>

      {extraElement}
    </div>
  );
};

export default SectionHeader;
